<template>
  <div v-if="error">{{ error }}</div>
  <ul class="flex flex-wrap rounded grid lg:grid-cols-3 gap-4 ">
    <li v-for="post in formattedPosts" :key="post.id">
      <router-link :to="{ name: 'PostDetails', params: { id: post.id } }">
        <figure class="md:flex rounded-lg bg-white dark:bg-gray-800  md:p-0">
          <div class="p-3">
            <h3 class="text-cyan-600 text-lg">{{ post.title }}</h3>
            <p class="mt-3">{{ post.chapters.length }} chapters</p>
            <p class="text-gray-400 text-sm italic" v-for="tag in post.tags" :key="tag">#{{ tag }}</p>
            <h4 class="text-gray-400 text-sm mb-1">author Mr / Ms {{ post.userName }}</h4>
            <h5 class="text-gray-400 text-sm italic ">{{ post.createdAt }}</h5>
          </div>
        </figure>
      </router-link>
    </li>
  </ul>
</template>

<script>
import getCollection from "@/composables/getCollection"
import { computed } from "vue"
import { formatDistanceToNow } from "date-fns"
export default {
  props: ["posts"],

  setup() {
    const { error, documents } = getCollection("posts")

    // format timestamp
    const formattedPosts = computed(() => {
      if (documents.value) {
        return documents.value.map((doc) => {
          let time = formatDistanceToNow(doc.createdAt.toDate())
          return { ...doc, createdAt: time }
        })
      }
    })

    return { error, documents, formattedPosts }
  },
}
</script>
